export default __webpack_public_path__ + "static/media/OneTimeTrade.ac70841a.svg";